<template>
  <a-modal
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :ok-text="okText"
    width="850px"
    style="top: 30px;"
  >
    <div slot="title" class="headerContent">
      <div>{{ title }}</div>
      <a-input-search placeholder="请输入搜索内容" style="width: 350px;margin-left: 30px;" v-model="keyword" @search="onSearch" />
    </div>
    <a-spin :spinning="loading">
      <a-table
        :columns="nameColumns"
        :data-source="allocationData"
        :pagination="pagination||false"
        :row-key="(record) => record.id"
        :row-selection="rowSelection"
        @change="tenantTableChange"
      >
        <template slot="rentname" slot-scope="text, record">
          {{ text || record.name }} ({{ record.id }})
        </template>
      </a-table>
    </a-spin>
  </a-modal>
</template>

<script>
const nameColumns = [
  {
    title: '租户名称',
    dataIndex: 'rentname',
    scopedSlots: { customRender: 'rentname' },
  },
]

export default {
  name: 'Allocation',
  inject: ['reload'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'XXX',
    },
    okText:{
      type: String,
      default: '确定',
    },
    dataList:{
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      allocationData: [],
      nameColumns,
      pagination: {
        current: 1, // 当前页数
        pageSize: 10, // 当前页显示数据的大小
        total: 0,
      },
      selectedItem: {},
      selectedKey: '',
      keyword: '', //搜索关键词
      loading: false,
    }
  },
  created() {
    this.getTenantInfoList()
  },
  computed: {
    rowSelection() {
      return {
        type: "radio", // 设置为单选模式
        selectedRowKeys: this.selectedKey ? [this.selectedKey] : [],
        onChange: (selectedRowKeys) => {
          const selectItem = this.allocationData.find(item => item.id === selectedRowKeys[0])
          if(selectItem) this.selectedItem = selectItem
          this.selectedKey = selectedRowKeys[0]; // 单选，取第一个
          this.$emit(this.selectedKey,"select", this.selectedKey); // 触发选择事件
        },
        getCheckboxProps: record => ({
          props:{
            disabled: this.shouldDisableRow(record)
          }
        }),
      };
    },
    selectedTIds(){
      const ids = this.dataList.filter(item => !item.isSystem && item.tenantId ).map(item2 => item2.tenantId)
      return ids
    }
  },
  methods: {
    // 判断是否应该禁用该行
    shouldDisableRow(record) {
      const { id = '' } = record || {}
      return id ? this.selectedTIds.includes(id) : false
    },

    onSearch(e){
      this.$set(this.pagination,'current',1)
      this.getTenantInfoList()
    },

    tenantTableChange({ pageSize, current }) {
      this.$set(this.pagination,'current',current)
      this.getTenantInfoList()
    },

    /* 获取租户列表列表 */
    getTenantInfoList() {
      this.loading = true
      const { current = 1, pageSize = 10 } = this.pagination || {}
      let params = {
        page: current,
        size: pageSize
      }
      if(this.keyword) params['key'] = this.keyword
      return new Promise((resolve, reject) => {
        /* 所有租户 */
        this.$api
          ._getTenantInfoList(params)
          .then((res) => {
            if (res.code == 0) {
              this.loading = false
              this.allocationData = res.data.content
              this.pagination.total = Number(res.data.totalElements)
              this.pagination.current = res.data.number + 1
              resolve()
            }
          })
          .catch(() => {
            this.loading = false
            reject()
          })
      })
    },

    /* 确认 */
    async handleOk() {
      const { selectedKey = '', selectedItem = {} } = this
      if( selectedKey && selectedItem.id ){
        const { id = '', name } = selectedItem || {}
        const params = {
          tenantId: id,
          tenantName: name,
          clientId: '',
          clientName: undefined,
          weixinEnabled: undefined,
          smtpDTO: {
            host:'',
            port:'',
            personalAlias:'',
            username:'',
            password:'',
            enableSSL: true,
          },
          smsDTO: [],
        }
        this.$api.addCustomization(params).then((res) => {
          if (res.code === 0) {
            this.handleCancel()
            this.$message.success('添加成功')
            this.$emit('refresh')
          }
        }).catch((err) => {
          this.$message.error('添加失败')
          console.log(err, '添加失败')
        })
      } else {
        this.$message.warning('请先选择租户')
      }
    },

    handleCancel() {
      this.$set(this.pagination,'current',1)
      this.selectedKey = ''
      this.keyword = ''
      this.loading = false
      this.$emit('update:visible', false)
    }
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-transfer {
  padding: 0 auto !important;
}
/deep/ .ant-modal{
  top: 50px;
}
/deep/ .ant-modal-body{
 padding: 0;
}
/deep/ .ant-table-pagination.ant-pagination {
  padding-right: 16px;
}
.headerContent{
  display: flex;
  align-items: center;
}
</style>
